import { components } from '@/common/bag-api';
import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';
import { Slot } from '@/reservation/reservation.model';

export interface TableColumn {
	field: TransportListColumns;
	width: `${string}${'px' | '%' | 'rem' | 'em' | 'pt'}`;
}

export type TransportListColumns =
	| 'Lp'
	| 'stopDeparture'
	| 'status'
	| 'unique'
	| 'bc'
	| 'firstName'
	| 'lastName'
	| 'slotCount'
	| 'seats'
	| 'comfort'
	| 'phone'
	| 'product'
	| 'note'
	| 'board'
	| 'accommodation'
	| 'otherCities'
	| 'birth'
	| 'vehicle'
	| 'surchargeCost'
	| 'nights'
	| 'signature'
	| 'address'
	| 'stopDepartureDate'
	| 'stopDepartureHour'
	| 'acceptanceSignature'
	| 'dedicationSignature'
	| 'insurer'
	| 'checkbox'
	| 'deliveryStatus'
	| 'isDataEntered'
	| 'isDepartureCheckIn'
	| 'isDepartureSent'
	| 'isReturnCheckIn'
	| 'isReturnSent'
	| 'kr'
	| 'departureTicket'
	| 'returnTicket'
	| 'userDocuments'
	| 'arrivalTime'
	| 'arrivalAirport'
	| 'departureFlightNumber'
	| 'returnDepartureTime'
	| 'returnAirport'
	| 'returnFlightNumber';

export type ReservationOfferTransport = CamelCaseKeys<components['schemas']['ReservationOfferComposite']>;

export interface OfferTransportList extends Omit<ReservationOfferTransport, 'slot'> {
	slot: Slot;
	reservationSlotCount: number;
}

export enum ListTabType {
	SMS,
	TGS,
	FEE,
	PASSPORT_LIST,
	TARGET_LIST,
}

export interface SMSPreviewResponse {
	city: string;
	isStopValid: boolean;
	message: string;
	phone: string;
	slotId: number;
	userData: {
		firstName: string;
		lastName: string;
		id: number;
	};
}

export interface SMSBulkSendPayload {
	phoneNumber: string;
	message: string;
	slot: number;
}

export interface SMSMessage {
	id: number;
	contentType: number;
	objectId: number;
	message: string;
	phone: string;
	wasSent: true;
	statusCode: number;
	errorMsg: string | null;
}
